import { FC } from "react";
import { Theme, themeRootClassMap } from "apps/website/maps/Theme.map";
import Column from "apps/website/components/layout/Column/Column";
import Grid from "apps/website/components/layout/Grid/Grid";
import Spacer from "apps/website/components/layout/Spacer/Spacer";

import TextTitle from "../../base/Text/TextTitle/TextTitle";
import TextBody from "../../base/Text/TextBody/TextBody";
import TextSubtitle from "../../base/Text/TextSubtitle/TextSubtitle";

export interface ILabelText {
  title: string;
  body?: string;
  labelPrefix?: string;
  label: string;
  labelSuffix?: string;
  theme?: Theme;
}

const LabelText: FC<ILabelText> = ({ title, body, labelPrefix, label, labelSuffix, theme = "light-grey" }) => {

  const getLabelTheme = (): Theme => {
    if ([ "dark", "footer" ].includes(theme)) {
      return "light-grey";
    }

    if ([ "dark-alt" ].includes(theme)) {
      return "light";
    }

    return "dark";
  };

  const getLabelColor = () => {
    if ([ "dark", "footer" ].includes(theme)) {
      return "secondary";
    }

    return "default";
  };

  return (
    <Grid component={LabelText.name} gap="lg">
      <Column spans={{ lg: 6 }}>
        <TextTitle tag="h2" size={1} className="text-center lg:text-left">{ title }</TextTitle>
        <Spacer size="lg" />
        { body && (
          <TextBody size={1} className="text-center lg:text-left">{ body }</TextBody>
        ) }
      </Column>
      <Column spans={{ lg: 6 }}>
        { labelPrefix && (
          <>
            <Grid>
              <Column spans={6} align="center" offset={4}>
                <TextSubtitle tag="h3" size={3} align="center" color={getLabelColor()}>{ labelPrefix }</TextSubtitle>
              </Column>
            </Grid>
            <Spacer size="lg" />
          </>
        ) }
        <div data-theme={getLabelTheme()} className={`my-3 flex h-full justify-center items-center px-3 py-8 transform -rotate-2 ${themeRootClassMap[getLabelTheme()]}`}>
          <TextBody size={4} className="uppercase" align="center">{ label }</TextBody>
        </div>
        { labelSuffix && (
          <>
            <Spacer size="lg" />
            <Grid>
              <Column spans={10} align="center" offset={2}>
                <TextSubtitle tag="h3" size={3} align="center" color={getLabelColor()}>{ labelSuffix }</TextSubtitle>
              </Column>
            </Grid>
          </>
        ) }
      </Column>
    </Grid>
  );
};

export default LabelText;
